import React, { Component } from "react";
import { connect } from "react-redux";
import styles from "./MediaListSlick.local.scss";
import _ from "i18n";

import MediaListSlickComponent from "./MediaListSlickComponent";

import { fetchMed } from "Thunks";

export class MediaListSlick extends Component {
  componentDidMount() {
    const { fetchMed } = this.props;

    fetchMed({ type: "ALL", limit: 42 });
  }

  render() {
    return (
      <section className={styles.simpleList}>
        <h2>{_("Recent media")}</h2>
        <MediaListSlickComponent {...this.props} />
      </section>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetching: state.medias.listing.fetching,
  fetched: state.medias.listing.fetched,
  medias: state.medias.listing.items,
  uploadingMedias: state.medias.uploading.items,
  community: state.params.navCommunity
});

const mapDispatchToProps = dispatch => ({
  fetchMed: options => dispatch(fetchMed(options))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MediaListSlick);



// WEBPACK FOOTER //
// ./src/components/Community/MediaListSlick/index.js